import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface ScenarioItem {
  id: string;
  icon: string;
  tag: string;
  title: string;
  subtitle: string;
  points: string[];
}

interface AgriScenariosProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    items: ScenarioItem[];
  };
}

export default function AgriScenarios({ data }: AgriScenariosProps) {
  const a = accent('green');

  return (
    <section id="scenarios" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        <Reveal className="mt-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {data.items.map((item) => (
              <div
                key={item.id}
                className="flex flex-col rounded-2xl bg-background-50 border border-background-200 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="flex items-start justify-between gap-3">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <span className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-[11px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>

                <h3 className="mt-4 font-heading font-bold text-foreground-950 text-lg leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1 text-sm text-accent-700">{item.subtitle}</p>

                <ul className="mt-4 flex flex-col gap-2.5">
                  {item.points.map((point) => (
                    <li key={point} className="flex gap-2.5">
                      <i className="ri-checkbox-circle-line text-accent-500 text-base mt-0.5 shrink-0"></i>
                      <span className="text-sm text-foreground-600 leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}